// This DataTable is failing for some reason
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import Plot from 'react-plotly.js';
import DataTable from 'react-data-table-component';
import './App.css';
import {calculateDaysUntilNextPayment} from './DebtFunctions';
import {formatCurrency, formatRate} from "./CoreFunctions";


const MortgageDetail = () => { 
    const { id } = useParams();  // Get mortgage ID from the URL
    const [mortgage, setMortgage] = useState(null); // State for mortgage details
    const [loading, setLoading] = useState(true);    // State for loading status
    const [amortizationSchedule, setAmortizationSchedule] = useState([]); // State for amortization schedule
    const [showRemainingOnly, setShowRemainingOnly] = useState(true); // State for toggle
    const [, setError] = useState('');

    // Graph tab state
    const [activeGraph, setActiveGraph] = useState('amortization'); // 'amortization' | 'breakdown'

    // Breakdown chart controls
    const [range, setRange] = useState('12m'); // 'all' | 'ytd' | '12m' | '24m'
    const [isCumulative, setIsCumulative] = useState(false);
    const [asPercent, setAsPercent] = useState(false);
    const [isStacked, setIsStacked] = useState(false);
    const [combinedEscrow, setCombinedEscrow] = useState(true);

    // Persist user legend selections (hidden traces) by trace name
    const [hiddenSeries, setHiddenSeries] = useState([]); // store as array of trace names

    // Helper to toggle a trace name in hiddenSeries
    const toggleHiddenSeries = (name) => {
        setHiddenSeries(prev => {
            const set = new Set(prev);
            if (set.has(name)) set.delete(name); else set.add(name);
            return Array.from(set);
        });
    };

    // When switching combined escrow mode, try to carry over selections between 'Escrow' and its sub-series
    useEffect(() => {
        setHiddenSeries(prev => {
            const set = new Set(prev);
            const escrowCombinedName = 'Escrow';
            const subNames = ['Property Tax Escrow', 'H.O. Insurance Escrow', 'Shortage/Overage Escrow'];
            if (combinedEscrow) {
                // Going to combined: if all sub series are hidden, also hide combined
                const allSubsHidden = subNames.every(n => set.has(n));
                if (allSubsHidden) set.add(escrowCombinedName);
            } else {
                // Going to split: if combined was hidden, hide all subs
                if (set.has(escrowCombinedName)) {
                    subNames.forEach(n => set.add(n));
                }
            }
            return Array.from(set);
        });
    }, [combinedEscrow]);

    // Escrow schedule state
    const [escrowSchedules, setEscrowSchedules] = useState([]);
    const [escrowTypeChoices, setEscrowTypeChoices] = useState([]);
    const [showEscrowModal, setShowEscrowModal] = useState(false);

    const [newEscrow, setNewEscrow] = useState({
        type: '',
        escrow_payment_amount: '',
        schedule_start_date: '',
        schedule_end_date: ''
    });
    const [escrowError, setEscrowError] = useState('');

    useEffect(() => {
        const fetchMortgageData = async () => {
            try {
                const response = await axios.get(`/api/balance_sheet/financing/mortgages/${id}/`);
                setMortgage(response.data);
                // Assume the amortization schedule is included in the response
                setAmortizationSchedule(response.data.amortization_schedule);
                console.log('Fetched Mortgage:', response.data);
                console.log('Amort Schedule:', response.data.amortization_data);
            } catch (error) {
                console.error('Error fetching mortgage details:', error);
                setError('Failed to fetch mortgage details.');
            } finally {
                setLoading(false);
            }
        };

        fetchMortgageData();
    }, [id]);  // Fetch data only when the mortgage ID changes

    // Load escrow schedules and choices
    useEffect(() => {
        const fetchEscrowData = async () => {
            try {
                const [schedRes, typesRes] = await Promise.all([
                    axios.get(`/api/balance_sheet/financing/mortgages/escrow_schedules/?mortgage=${id}`),
                    axios.get('/api/balance_sheet/financing/mortgages/escrow-type-choices/')
                ]);
                const data = Array.isArray(schedRes.data) ? schedRes.data : [];
                const sorted = data.slice().sort((a,b)=> new Date(a.schedule_start_date) - new Date(b.schedule_start_date));
                setEscrowSchedules(sorted);
                setEscrowTypeChoices(Array.isArray(typesRes.data) ? typesRes.data : []);
            } catch (e) {
                console.error('Error fetching escrow schedules:', e);
            }
        };
        if (id) fetchEscrowData();
    }, [id]);

    //     // Function to calculate the number of days until the next payment
    // const calculateDaysUntilNextPayment = (paymentDateString) => {
    //     // Parse the payment date string into a Date object.
    //     const paymentDate = new Date(paymentDateString);
    //
    //     // Get the current date.
    //     const currentDate = new Date();
    //
    //     // Calculate the difference in time (milliseconds).
    //     const timeDifference = paymentDate - currentDate;
    //
    //     // Convert from milliseconds to days.
    //     const daysUntilNextPayment = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Using Math.ceil to round up
    //
    //     return daysUntilNextPayment < 0 ? 0 : daysUntilNextPayment; // Prevent negative days
    // };
    //
    // // Helper function to format currency
    // const formatCurrency = (amount, decimalPlaces = 2) => {
    //     // Ensure the amount is a number and format to the specified decimal places
    //     const roundedAmount = Number(amount).toFixed(decimalPlaces);
    //
    //     // Use toLocaleString to add commas for thousands and format to decimal places
    //     return `$${parseFloat(roundedAmount).toLocaleString(undefined, { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces })}`;
    // };

    console.log('Check amort sched:', amortizationSchedule)
    // Prepare filtered amortization schedule based on the toggle state
    const filteredSchedule = showRemainingOnly
        ? amortizationSchedule.filter(row => new Date(row.payment_date) > new Date())
        : amortizationSchedule;

    const handleEscrowAdd = async (e) => {
        e.preventDefault();
        setEscrowError('');
        try {
            const payload = {
                ...newEscrow,
                mortgage: parseInt(id, 10),
            };
            // Convert empty end date to null
            if (!payload.schedule_end_date) delete payload.schedule_end_date;
            const res = await axios.post('/api/balance_sheet/financing/mortgages/escrow_schedules/', payload);
            setEscrowSchedules(prev => [...prev, res.data].sort((a,b)=> new Date(a.schedule_start_date) - new Date(b.schedule_start_date)));
            setNewEscrow({ type: '', escrow_payment_amount: '', schedule_start_date: '', schedule_end_date: '' });
        } catch (err) {
            console.error('Error adding escrow schedule:', err);
            const msg = err.response?.data || err.message;
            setEscrowError(typeof msg === 'string' ? msg : JSON.stringify(msg));
        }
    };

    const handleEscrowFieldChange = (id, field, value) => {
        setEscrowSchedules(prev => prev.map(row => row.id === id ? { ...row, [field]: value } : row));
    };

    const handleEscrowSave = async (row) => {
        try {
            const payload = { ...row };
            // Avoid sending mortgage as an object; ensure it's id
            payload.mortgage = row.mortgage?.id || row.mortgage || parseInt(id, 10);
            // Do not send legacy shortage_overage_amount; use separate schedule type instead
            if ('shortage_overage_amount' in payload) delete payload.shortage_overage_amount;
            if (payload.schedule_end_date === '') delete payload.schedule_end_date;
            const res = await axios.patch(`/api/balance_sheet/financing/mortgages/escrow_schedules/${row.id}/`, payload);
            setEscrowSchedules(prev => prev.map(r => r.id === row.id ? res.data : r).sort((a,b)=> new Date(a.schedule_start_date) - new Date(b.schedule_start_date)));
            setEscrowError('');
        } catch (err) {
            console.error('Error saving escrow schedule:', err);
            const msg = err.response?.data || err.message;
            setEscrowError(typeof msg === 'string' ? msg : JSON.stringify(msg));
        }
    };

    // Prepare data for the Plotly chart based on filtered data (Amortization line chart)
    const xData = filteredSchedule.map(row => new Date(row.payment_date)); // Dates for the x-axis
    const principalPayments = filteredSchedule.map(row => parseFloat(row.principal_payment_amount) || 0); // Y-values for principal payments
    const interestPayments = filteredSchedule.map(row => parseFloat(row.interest_payment_amount) || 0); // Y-values for interest payments

    // Helpers for Breakdown bar chart
    const toNumber = (v) => {
        if (v == null) return 0;
        if (typeof v === 'object' && 'amount' in v) return Number(v.amount) || 0;
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    };

    const computeEscrow = (row) =>
        toNumber(row.property_tax_escrow) + toNumber(row.homeowners_insurance_escrow) + toNumber(row.shortage_overage_escrow);

    const getRangeFilteredSchedule = () => {
        const all = (amortizationSchedule || []).slice().sort((a,b)=> new Date(a.payment_date) - new Date(b.payment_date));
        if (all.length === 0) return all;

        // Cap at today: only include payments on or before today
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const past = all.filter(r => {
            const d = new Date(r.payment_date);
            return d <= today;
        });

        if (past.length === 0) return [];

        if (range === 'all') return past;

        // determine latest past date available (<= today)
        const latest = new Date(past[past.length - 1].payment_date);
        let start;
        if (range === 'ytd') {
            start = new Date(latest.getFullYear(), 0, 1);
        } else if (range === '12m') {
            start = new Date(latest);
            start.setMonth(start.getMonth() - 11);
            start.setDate(1);
        } else if (range === '24m') {
            start = new Date(latest);
            start.setMonth(start.getMonth() - 23);
            start.setDate(1);
        } else {
            start = new Date(past[0].payment_date);
        }
        return past.filter(r => {
            const d = new Date(r.payment_date);
            return d >= start && d <= latest;
        });
    };

    const breakdownRows = getRangeFilteredSchedule();
    const breakdownX = breakdownRows.map(r => new Date(r.payment_date));
    const basePrincipal = breakdownRows.map(r => toNumber(r.principal_payment_amount));
    const baseInterest = breakdownRows.map(r => toNumber(r.interest_payment_amount));
    const baseEscrow = breakdownRows.map(r => computeEscrow(r));
    const basePropTax = breakdownRows.map(r => toNumber(r.property_tax_escrow));
    const baseHomeIns = breakdownRows.map(r => toNumber(r.homeowners_insurance_escrow));
    const baseShortOver = breakdownRows.map(r => toNumber(r.shortage_overage_escrow));
    const baseTotal = breakdownRows.map(r => toNumber(r.total_payment_amount));

    const cumulative = (arr) => {
        let sum = 0; return arr.map(v => (sum += v));
    };

    // Transform for cumulative/percent modes
    let chartPrincipal = basePrincipal.slice();
    let chartInterest = baseInterest.slice();
    let chartEscrow = baseEscrow.slice();
    let chartPropTax = basePropTax.slice();
    let chartHomeIns = baseHomeIns.slice();
    let chartShortOver = baseShortOver.slice();

    if (isCumulative) {
        chartPrincipal = cumulative(chartPrincipal);
        chartInterest = cumulative(chartInterest);
        chartEscrow = cumulative(chartEscrow);
        chartPropTax = cumulative(chartPropTax);
        chartHomeIns = cumulative(chartHomeIns);
        chartShortOver = cumulative(chartShortOver);
    }

    if (asPercent) {
        if (isCumulative) {
            const totalCum = cumulative(baseTotal.slice());
            const div = (arr) => arr.map((v,i)=> totalCum[i] ? (v/totalCum[i])*100 : 0);
            chartPrincipal = div(chartPrincipal);
            chartInterest = div(chartInterest);
            chartEscrow = div(chartEscrow);
            chartPropTax = div(chartPropTax);
            chartHomeIns = div(chartHomeIns);
            chartShortOver = div(chartShortOver);
        } else {
            const div = (arr) => arr.map((v,i)=> baseTotal[i] ? (v/baseTotal[i])*100 : 0);
            chartPrincipal = div(chartPrincipal);
            chartInterest = div(chartInterest);
            chartEscrow = div(chartEscrow);
            chartPropTax = div(chartPropTax);
            chartHomeIns = div(chartHomeIns);
            chartShortOver = div(chartShortOver);
        }
    }

    const columns = [
        { name: 'Payment Date', selector: row => row.payment_date, sortable: true },
        { name: 'Total Payment Amount', selector: row => formatCurrency(row.total_payment_amount), sortable: true },
        { name: 'Loan Payment Amount', selector: row => formatCurrency(row.loan_payment_amount), sortable: true },
        { name: 'Principal Payment', selector: row => formatCurrency(row.principal_payment_amount), sortable: true },
        { name: 'Interest Payment', selector: row => formatCurrency(row.interest_payment_amount), sortable: true },
        { name: 'Property Tax Escrow', selector: row => formatCurrency(row.property_tax_escrow), sortable: true },
        { name: 'Homeowners Insurance Escrow', selector: row => formatCurrency(row.homeowners_insurance_escrow), sortable: true },
        { name: 'Shortage/Overage Escrow', selector: row => formatCurrency(row.shortage_overage_escrow), sortable: true },
        { name: 'Outstanding Balance', selector: row => formatCurrency(row.outstanding_balance, 0), sortable: true },
        { name: 'Remaining Outstanding %', selector: row => `${parseFloat(row.percent_outstanding).toFixed(2)}%`, sortable: true },
        { name: 'Cumulative Payments', selector: row => formatCurrency(row.cumulative_recurring_payment_amt, 0), sortable: true },
        { name: 'Cumulative Interest Payments', selector: row => formatCurrency(row.cumulative_interest_payment_amt, 0), sortable: true },
        { name: 'Cumulative Principal Payments', selector: row => formatCurrency(row.cumulative_principal_payment_amt, 0), sortable: true },
        { name: 'Cumulative Interest Paid (% of Loan)', selector: row => `${parseFloat(row.interest_paid_as_perc_of_loan_amt).toFixed(2)}%`, sortable: true },
        { name: 'Cumulative Cost of Loan', selector: row => formatCurrency(row.total_cost_of_loan_to_date_amt, 0), sortable: true },
        { name: 'Cumulative Cost of Loan (% of Loan)', selector: row => `${parseFloat(row.total_cost_of_loan_to_date_perc).toFixed(2)}%`, sortable: true },
    ];

    // Dark theme styles for DataTable to match app tables
    const dataTableStyles = {
        table: {
            style: { backgroundColor: '#111827' }
        },
        headRow: {
            style: { backgroundColor: '#1f2937', color: '#e5e7eb', borderBottom: '1px solid #374151' }
        },
        headCells: {
            style: { color: '#e5e7eb' }
        },
        rows: {
            style: { backgroundColor: '#111827', color: '#e5e7eb', borderBottom: '1px solid #374151' },
            highlightOnHoverStyle: { backgroundColor: '#0b1220', color: '#e5e7eb' }
        },
        pagination: {
            style: { backgroundColor: '#111827', color: '#e5e7eb', borderTop: '1px solid #374151' },
            pageButtonsStyle: { fill: '#e5e7eb', color: '#e5e7eb' }
        }
    };

    const conditionalRowStyles = [
        { when: (_row, index) => index % 2 === 1, style: { backgroundColor: '#0f172a' } }
    ];

    // Initialize daysUntilPayment in a safe way
    let daysUntilPayment = null;

    // Check if mortgage and upcoming_payment are not null before calculating
    if (mortgage && mortgage.upcoming_payment) {
        daysUntilPayment = calculateDaysUntilNextPayment(mortgage.upcoming_payment.payment_date);
    }

    if (loading) return <div>Loading mortgage details...</div>; // Show loading message
    if (!mortgage) return <div>No mortgage found!</div>; // Handle case where no data is found


return (
        <div className="content-container">
            <h1>Mortgage Details: {mortgage.address.street_address}, {mortgage.address.city}, {mortgage.address.state}</h1>

            {/* Container for Stats and Graph */}
            <div className="top-section">
                <div className="loan-stats">
                    <p><strong>Upcoming Payment: </strong></p>
                    {mortgage.upcoming_payment ? (
                        <>
                            <p style={{ marginLeft: '30px' }}>Date: {mortgage.upcoming_payment.payment_date} (in {daysUntilPayment} days)</p>
                            <p style={{ marginLeft: '30px' }}>Amount: {formatCurrency((() => {
                                const up = mortgage.upcoming_payment;
                                // Try to find matching row in amortization_schedule
                                const row = (amortizationSchedule || []).find(r => r.payment_date === up.payment_date);
                                if (row && (row.total_payment_amount != null)) return row.total_payment_amount;
                                // Fallback: base + escrow fields if present on upcoming_payment
                                const toNum = (v) => {
                                    if (v == null) return 0;
                                    if (typeof v === 'object' && 'amount' in v) return Number(v.amount) || 0;
                                    const n = Number(v); return Number.isFinite(n) ? n : 0;
                                };
                                const base = toNum(up.loan_payment_amount);
                                const pt = toNum(up.property_tax_escrow);
                                const hi = toNum(up.homeowners_insurance_escrow);
                                const so = toNum(up.shortage_overage_escrow);
                                return base + pt + hi + so;
                            })())}</p>
                            <p style={{ marginLeft: '30px' }}>Rate: {formatRate(mortgage.current_rate, 2)}</p>
                        </>
                    ) : (
                        <p style={{ marginLeft: '30px' }}>No upcoming payment available.</p>
                    )}
                    <p><strong>Loan Stats: </strong></p>
                    {mortgage.recent_payment ? (
                        <p style={{ marginLeft: '30px' }}>
                            Outstanding: {formatCurrency(mortgage.recent_payment.outstanding_balance)} ({formatRate(mortgage.recent_payment.percent_outstanding, 2)})
                        </p>
                    ) : (
                        <p style={{ marginLeft: '30px' }}>No recent payment data available.</p>
                    )}
                    <p><strong>Linked Asset: </strong></p>
                    {mortgage.asset_info ? (
                        <p style={{ marginLeft: '30px' }}>
                            <Link to={(() => {
                                const ai = mortgage.asset_info || {};
                                const id = ai.id;
                                const t2 = (ai.type_2 || '').toLowerCase();
                                if (t2 === 'resi_property' || t2 === 'residential_property') return `/balance_sheet/assets/physical_assets/resi_properties/${id}`;
                                if (t2 === 'land') return `/balance_sheet/assets/physical_assets/resi_properties/land/${id}`;
                                if (t2 === 'structure' || t2 === 'structures') return `/balance_sheet/assets/physical_assets/resi_properties/structures/${id}`;
                                if (t2 === 'vehicle') return `/balance_sheet/assets/physical_assets/vehicles/${id}`;
                                return `/balance_sheet/assets`;
                            })()}>{mortgage.asset_info.description}</Link>
                        </p>
                    ) : (
                        <p style={{ marginLeft: '30px' }}>None</p>
                    )}
                </div>

                <div className="graph-container">

                    {activeGraph === 'amortization' && (
                        <Plot
                            data={[
                                { x: xData, y: principalPayments, type: 'scatter', mode: 'lines+markers', name: 'Principal' },
                                { x: xData, y: interestPayments, type: 'scatter', mode: 'lines+markers', name: 'Interest' },
                            ]}
                            layout={{
                                template: 'plotly_dark',
                                paper_bgcolor: '#0b1220',
                                plot_bgcolor: '#0b1220',
                                font: { color: '#e5e7eb' },
                                title: { text: 'Amortization Schedule', font: { weight: 'bold' } },
                                xaxis: { title: 'Payment Date', gridcolor: '#374151', zerolinecolor: '#374151' },
                                yaxis: { title: 'Payment Amount', gridcolor: '#374151', zerolinecolor: '#374151' },
                                legend: { orientation: 'h', entrywidthmode: 'fraction', entrywidth: 0.33, x: 0, xanchor: 'left', y: -0.25, yanchor: 'bottom', bgcolor: 'rgba(0,0,0,0)' },
                                margin: { t: 40, b: 160, l: 60, r: 20 }
                            }}
                            config={{ displayModeBar: false }}
                        />
                    )}

                    {activeGraph === 'breakdown' && (
                        <div>
                            {/* Controls above chart */}
                            <div className="chart-controls" style={{ marginBottom: '12px' }}>
                                <div className="control-group">
                                    <span className="control-label">Period:</span>
                                    <select className="control-select" value={range} onChange={(e)=> setRange(e.target.value)}>
                                        <option value="12m">Last 12 months</option>
                                        <option value="24m">Last 24 months</option>
                                        <option value="ytd">YTD</option>
                                        <option value="all">All</option>
                                    </select>
                                </div>
                                <div className="control-group">
                                    <button type="button" className={`btn-toggle ${isCumulative ? 'btn-active' : ''}`} onClick={()=> setIsCumulative(v=>!v)}>Cumulative</button>
                                    <button type="button" className={`btn-toggle ${asPercent ? 'btn-active' : ''}`} onClick={()=> setAsPercent(v=>!v)}>%</button>
                                    <button type="button" className={`btn-toggle ${isStacked ? 'btn-active' : ''}`} onClick={()=> setIsStacked(v=>!v)}>Stacked</button>
                                    <button type="button" className={`btn-toggle ${combinedEscrow ? 'btn-active' : ''}`} onClick={()=> setCombinedEscrow(v=>!v)}>Combined Escrow</button>
                                </div>
                            </div>
                            <Plot
                                data={(function(){
                                    const hidden = new Set(hiddenSeries);
                                    const withVis = (trace) => ({ ...trace, visible: hidden.has(trace.name) ? 'legendonly' : true });
                                    const traces = [
                                        withVis({ x: breakdownX, y: chartPrincipal, type: 'bar', name: 'Principal' }),
                                        withVis({ x: breakdownX, y: chartInterest, type: 'bar', name: 'Interest' }),
                                    ];
                                    if (combinedEscrow) {
                                        traces.push(withVis({ x: breakdownX, y: chartEscrow, type: 'bar', name: 'Escrow' }));
                                    } else {
                                        traces.push(
                                            withVis({ x: breakdownX, y: chartPropTax, type: 'bar', name: 'Property Tax Escrow' }),
                                            withVis({ x: breakdownX, y: chartHomeIns, type: 'bar', name: 'H.O. Insurance Escrow' }),
                                            withVis({ x: breakdownX, y: chartShortOver, type: 'bar', name: 'Shortage/Overage Escrow' }),
                                        );
                                    }
                                    return traces;
                                })()}
                                layout={{
                                    barmode: isStacked ? 'stack' : 'group',
                                    template: 'plotly_dark',
                                    paper_bgcolor: '#0b1220',
                                    plot_bgcolor: '#0b1220',
                                    font: { color: '#e5e7eb' },
                                    title: { text: 'Payment Breakdown', font: { weight: 'bold' } },
                                    xaxis: { title: 'Payment Date', gridcolor: '#374151', zerolinecolor: '#374151' },
                                    yaxis: { title: asPercent ? 'Percent of Total (%)' : 'Amount ($)', gridcolor: '#374151', zerolinecolor: '#374151' },
                                    legend: { orientation: 'h', entrywidthmode: 'fraction', entrywidth: 0.33, x: 0, xanchor: 'left', y: -0.25, yanchor: 'bottom', bgcolor: 'rgba(0,0,0,0)' },
                                    margin: { t: 40, b: 160, l: 60, r: 20 }
                                }}
                                config={{ displayModeBar: false }}
                                onLegendClick={(e) => {
                                    try {
                                        const name = e?.data?.[e?.curveNumber]?.name;
                                        if (name) toggleHiddenSeries(name);
                                    } catch (_) {}
                                    // Prevent plotly from doing its own toggle so we stay controlled
                                    return false;
                                }}
                            />
                        </div>
                    )}
                    {/* Chart type tabs below */}
                    <div style={{ display:'flex', flexDirection:'column', gap:'8px', marginTop:'8px' }}>
                        <button onClick={()=> setActiveGraph('amortization')} className={activeGraph==='amortization' ? 'tab-active' : 'tab'}>Amortization</button>
                        <button onClick={()=> setActiveGraph('breakdown')} className={activeGraph==='breakdown' ? 'tab-active' : 'tab'}>Payment Breakdown</button>
                    </div>
                </div>
            </div>

            {/* Toolbar above DataTable: left = remaining toggle, right = Add/Edit */}
            <div className="content-container">
                <div className="table-toolbar">
                    <label className="checkbox-label">
                        <input
                            type="checkbox"
                            checked={showRemainingOnly}
                            onChange={() => setShowRemainingOnly(!showRemainingOnly)}
                        />
                        <span className="checkbox-text">Show only remaining payments</span>
                    </label>
                    <button className="btn-primary" onClick={() => setShowEscrowModal(true)}>Add / Edit Escrow Schedules</button>
                </div>

            {/* Container for DataTable */}
            <div className="data-table-container">
                <DataTable
                    title="Amortization Schedule Table"
                    columns={columns}
                    data={filteredSchedule}
                    pagination
                    paginationPerPage={50}
                    striped={false}
                    highlightOnHover
                    customStyles={dataTableStyles}
                    conditionalRowStyles={conditionalRowStyles}
                    persistTableHead
                />
            </div>

            {/* Escrow Schedules Modal */}
            {showEscrowModal && (
                    <div style={{ position: 'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
                        <div style={{ background:'#fff', padding:'20px', borderRadius:'8px', width:'90%', maxWidth:'900px', maxHeight:'80%', overflow:'auto' }}>
                            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                                <h3>Manage Escrow Schedules</h3>
                                <button onClick={() => setShowEscrowModal(false)}>Close</button>
                            </div>
                            {/* Add form */}
                            <form onSubmit={handleEscrowAdd} style={{ display:'flex', gap:'12px', alignItems:'flex-end', flexWrap:'wrap', marginTop:'10px' }}>
                                <div>
                                    <label>Type<br/>
                                        <select value={newEscrow.type} onChange={e=> setNewEscrow(prev=>({ ...prev, type: e.target.value }))} required>
                                            <option value="">Select type</option>
                                            {escrowTypeChoices.map(([val, label]) => (
                                                <option key={val} value={val}>{label}</option>
                                            ))}
                                        </select>
                                    </label>
                                </div>
                                <div>
                                    <label>Base Escrow Amount<br/>
                                        <input type="number" step="0.01" value={newEscrow.escrow_payment_amount} onChange={e=> setNewEscrow(prev=>({ ...prev, escrow_payment_amount: e.target.value }))} required />
                                    </label>
                                </div>
                                <div>
                                    <label>Start Date<br/>
                                        <input type="date" value={newEscrow.schedule_start_date} onChange={e=> setNewEscrow(prev=>({ ...prev, schedule_start_date: e.target.value }))} required />
                                    </label>
                                </div>
                                <div>
                                    <label>End Date (optional)<br/>
                                        <input type="date" value={newEscrow.schedule_end_date} onChange={e=> setNewEscrow(prev=>({ ...prev, schedule_end_date: e.target.value }))} />
                                    </label>
                                </div>
                                <button type="submit">Add Schedule</button>
                            </form>
                            {escrowError && <div style={{ color:'red', marginTop:'8px' }}>{escrowError}</div>}

                            {/* Existing schedules table */}
                            <div style={{ marginTop:'16px', border:'1px solid #ddd', borderRadius:'6px', padding:'8px', maxHeight:'250px', overflowY:'auto' }}>
                                <div style={{ display:'grid', gridTemplateColumns:'160px 160px 160px 160px 120px', gap:'8px', fontWeight:'bold', borderBottom:'1px solid #eee', paddingBottom:'8px' }}>
                                    <div>Type</div>
                                    <div>Amount</div>
                                    <div>Start Date</div>
                                    <div>End Date</div>
                                    <div>Actions</div>
                                </div>
                                {escrowSchedules.map(row => (
                                    <div key={row.id} style={{ display:'grid', gridTemplateColumns:'160px 160px 160px 160px 120px', gap:'8px', alignItems:'center', padding:'6px 0', borderBottom:'1px solid #f3f3f3' }}>
                                        <select value={row.type} onChange={e=> handleEscrowFieldChange(row.id, 'type', e.target.value)}>
                                            {escrowTypeChoices.map(([val, label]) => (
                                                <option key={val} value={val}>{label}</option>
                                            ))}
                                        </select>
                                        <input type="number" step="0.01" value={row.escrow_payment_amount} onChange={e=> handleEscrowFieldChange(row.id, 'escrow_payment_amount', e.target.value)} />
                                        <input type="date" value={row.schedule_start_date} onChange={e=> handleEscrowFieldChange(row.id, 'schedule_start_date', e.target.value)} />
                                        <input type="date" value={row.schedule_end_date || ''} onChange={e=> handleEscrowFieldChange(row.id, 'schedule_end_date', e.target.value)} />
                                        <button onClick={()=> handleEscrowSave(row)}>Save</button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MortgageDetail;
